import gql from 'graphql-tag';
import { spaceTypeGQLFields } from './spaceType.fields.js';
export function getSpaceTypesGQLQuery(fields) {
    return gql `
    query GetSpaceTypes(
      $limit: Int!
      $orderBy: SpaceTypeListOrderByEnum
      $reverse: Boolean
    ) {
      spaceTypes(limit: $limit, orderBy: $orderBy, reverse: $reverse) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            ${spaceTypeGQLFields(fields)}
          }
        }
      }
    }
  `;
}
export const spaceTypeGQLQuery = (fields) => gql `
  query SpaceType($id: ID!) {
    spaceType(id: $id) {
      ${spaceTypeGQLFields(fields)}
    }
  }
`;
export const createSpaceTypeGQLMutation = (fields) => gql `
  mutation CreateSpaceType($input: CreateSpaceTypeInput!) {
    createSpaceType(input: $input) {
      ${spaceTypeGQLFields(fields)}
    }
  }
`;
//# sourceMappingURL=spaceTypes.gql.js.map